// useJobChats (issue #419) — every thread attached to a job.
//
// Reads `GET /chats/jobs/:jobId`. Lead-or-admin only on the server side;
// the hook just forwards the call.

import { useQuery, UseQueryOptions } from '@tanstack/react-query';

import { getJobChats } from './api';
import { chatKeys } from './keys';

import type { Chat } from 'src/models/chat';

export function useJobChats(
  jobId: number | undefined,
  options?: UseQueryOptions<Chat[]>
) {
  return useQuery<Chat[]>(
    chatKeys.jobChats(jobId ?? 0),
    () => getJobChats(jobId as number),
    {
      enabled: typeof jobId === 'number' && jobId > 0,
      ...options,
    }
  );
}
